"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Keywords;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Keywords(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "keywords"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "outline-4",
    "data-name": "outline",
    d: "M81.771,14.913a18.138,18.138,0,0,0-27.3,23.762l-41.2,41.2a2.5,2.5,0,0,0,0,3.535l10.451,10.45a2.5,2.5,0,0,0,3.535-3.535l-8.683-8.683,4.876-4.875,6.7,6.7a2.5,2.5,0,0,0,3.536-3.535l-6.7-6.7L58.01,42.21a18.138,18.138,0,0,0,23.761-27.3Zm-3.535,22.13a13.143,13.143,0,1,1,0-18.595A13.165,13.165,0,0,1,78.236,37.043Z"
  }))));
}